import _jsx from '@babel/runtime/helpers/esm/jsx';
import _styled from 'styled-components';
import { memo } from 'react';
import Text from '@dbh/text';
import { useMakeSelect } from '@dbh/reselect-extra';
import { makeSelectDbhAggregateRating } from '@dbh/webpages-redux';

const SITE_RATINGS_REFERENCE="dbh-site-ratings",SiteRatings=/*#__PURE__*/memo(()=>{const a=useMakeSelect(makeSelectDbhAggregateRating);return a?/*#__PURE__*/_jsx(_StyledText,{align:"center",padding:"0 0 sp7",color:"blackMid",size:"ff9",lineHeight:"l2",intlFormatterValues:a,intlFormatter:!0},void 0,"packages.site-ratings.text"):null});SiteRatings.displayName="DbhAggregateRating",SiteRatings.dbhNavigationMenuReference="dbh-site-ratings";var _StyledText=/*#__PURE__*/_styled(Text).withConfig({componentId:"sc-98v1m7-0"})(["width:100%;display:block;"]);

export { SITE_RATINGS_REFERENCE, SiteRatings as default };
